module.exports = __webpack_public_path__ + "static/media/internet-of-things06.5486ab31.jpg";